@if (isFormReady) {
  <pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
    @for (tab of tabs; track tab.value) {
      <pdq-tab [label]="tab.label" [value]="tab.value" [disabled]="tab.disabled" [locked]="tab.locked"></pdq-tab>
    }
  </pdq-tabs-group>

  <form [formGroup]="formGroup">
    <div class="container">
      @switch (activeTab) {
        @case (CheckoutContentTab.SETTINGS) {
          <checkout-content-settings
            [formGroup]="formGroup"
            [usageTokenControl]="usageTokenControl"
            [shop$]="shop$"
            [shopCurrencySymbol]="shopCurrencySymbol"
            [dynamicFieldsAutocompleteOptions$]="dynamicFieldsAutocompleteOptions$"
            [defaultIconUrl]="defaultIconUrl"
            [placementModeConfig]="placementModeConfig"
            [styleOptions]="styleOptions"
            [blockTypeOptions]="blockTypeOptions"
            [borderTypeOptions]="borderTypeOptions"
            [borderWidthOptions]="borderWidthOptions"
            [cornerRadiusOptions]="cornerRadiusOptions"
            [paddingOptions]="paddingOptions"
            [MIN_BLOCKS]="MIN_BLOCKS"
            [MAX_BLOCKS]="MAX_BLOCKS"
            (styleTypeChange)="onStyleTypeChange($event)"
            (blockTypeChange)="handleBlockTypeChange($event.option, $event.index)"
            (previewChange)="onPreviewChange($event.imagePreviewBase64, $event.index)"
            (clearImage)="onClearImage($event)"
            (checkUrl)="handleClickCheckUrl($event)">
          </checkout-content-settings>
        }
        @case (CheckoutContentTab.DISPLAY_CONDITIONS) {
          <checkout-content-display-conditions
            [formGroup]="formGroup"
            [shopCurrencySymbol]="shopCurrencySymbol"></checkout-content-display-conditions>
        }
        @case (CheckoutContentTab.TIMER) {
          <timer-configuration [timerControl]="formGroup.get('timerConfiguration')" [extensionType]="'checkoutContent'">
          </timer-configuration>
        }
      }
    </div>
  </form>
}
